export const GA_EVENT_NAME = 'tailwind-not-support';

export const PAGE_URL = '/not-support';
